module.exports = __webpack_public_path__ + "img/check_in-out3.27034d32.png";